<template>
  <div
    v-loading="loading"
    style="width: 100%;"
    :class="className"
  >
    <slot name="header" />
    <div
      :style="{marginBottom: safeBottomHeight, 'paddingLeft': paddingLeft, 'paddingRight': paddingRight}"
    >
      <div :style="innerStyle">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    loading: {},
    align: {},
    maxWidth: {},
    className: {},
    safeBottomHeight: {},
    paddingLeft: {
      type: String,
      default: '40px'
    },
    paddingRight: {
      type: String,
      default: '40px'
    }
  },
  computed: {
    innerStyle() {
      return {
        maxWidth: this.maxWidth || '100%',
        margin: this.align === 'center' ? '12px auto' : '12px 0 0 0'
      };
    }
  }
};
</script>
